import { Injectable } from "@angular/core"
import { Actions, Effect } from "@ngrx/effects"
import { Action } from "@ngrx/store"
import { TermService } from "@services/term"
import { PublicHolidayService } from "@services/public-holiday"
import { Term } from "@models/term"
import { Observable } from "rxjs/Observable"
import {
  UPDATE_TERM,
  UPDATE_TERM_FAILURE,
  POPULATE_EDITABLE_TERM,
  CREATE_TERM,
  UPDATE_PUBLIC_HOLIDAY,
  POPULATE_EDITABLE_PUBLIC_HOLIDAY,
  CREATE_PUBLIC_HOLIDAY,
  DESTROY_PUBLIC_HOLIDAY,
  DESTROY_PUBLIC_HOLIDAY_FAILURE,
  FETCH_CALENDAR_TERMS_FAILURE,
  FETCH_CALENDAR_TERMS,
  POPULATE_CALENDAR_TERMS
} from "../calendar"
import { FETCH_CONSTANTS } from "@reducers/constants"
import { PublicHoliday } from "@models/public-holiday"

@Injectable()
export class CalendarEffects {

  constructor(
    private actions: Actions,
    private termService: TermService,
    private publicHolidayService: PublicHolidayService,
  ) {}

  @Effect() fetchTerms = this.actions
    .ofType(FETCH_CALENDAR_TERMS)
    .switchMap(() => this.termService.fetchTerms()
      .map((terms: Term[]) => ({ type: POPULATE_CALENDAR_TERMS, payload: terms }))
      .catch(() => Observable.of({ type: FETCH_CALENDAR_TERMS_FAILURE }))
    )
    .share()

  @Effect() createTerm = this.actions
    .ofType(CREATE_TERM)
    .map((action: Action) => action.payload)
    .switchMap((term: Term) => this.termService.create(term.serializeForRails())
      .mergeMap((term: Term) => {
        return [
          { type: POPULATE_EDITABLE_TERM, payload: term },
          { type: FETCH_CONSTANTS },
        ]
      })
      .catch((response: any) => Observable.of({ type: UPDATE_TERM_FAILURE, payload: response }))
    )
    .share()

  @Effect() updateTerm = this.actions
    .ofType(UPDATE_TERM)
    .map((action: Action) => action.payload)
    .switchMap((term: Term) => this.termService.update(term.serializeForRails())
      .mergeMap((term: Term) => {
        return [
          { type: POPULATE_EDITABLE_TERM, payload: term },
          { type: FETCH_CONSTANTS },
        ]
      })
      .catch((response: any) => Observable.of({ type: UPDATE_TERM_FAILURE, payload: response }))
    )
    .share()

  @Effect() createPublicHoliday = this.actions
    .ofType(CREATE_PUBLIC_HOLIDAY)
    .map((action: Action) => action.payload)
    .switchMap((publicHoliday: PublicHoliday) => this.publicHolidayService.create(publicHoliday.serializeForRails())
      .mergeMap((publicHoliday: PublicHoliday) => {
        return [
          { type: POPULATE_EDITABLE_PUBLIC_HOLIDAY, payload: publicHoliday },
          { type: FETCH_CONSTANTS },
        ]
      })
      .catch((response: any) => Observable.of({ type: UPDATE_TERM_FAILURE, payload: response }))
    )
    .share()

  @Effect() updatePublicHoliday = this.actions
    .ofType(UPDATE_PUBLIC_HOLIDAY)
    .map((action: Action) => action.payload)
    .switchMap((publicHoliday: PublicHoliday) => this.publicHolidayService.update(publicHoliday.serializeForRails())
      .mergeMap((publicHoliday: PublicHoliday) => {
        return [
          { type: POPULATE_EDITABLE_PUBLIC_HOLIDAY, payload: publicHoliday },
          { type: FETCH_CONSTANTS },
        ]
      })
      .catch((response: any) => Observable.of({ type: UPDATE_TERM_FAILURE, payload: response }))
    )
    .share()

  @Effect() destroyPublicHoliday = this.actions
    .ofType(DESTROY_PUBLIC_HOLIDAY)
    .map((action: Action) => action.payload)
    .switchMap((id: number) => this.publicHolidayService.destroy(id)
      .map(() => ({ type: FETCH_CONSTANTS })) 
      .catch((response: any) => Observable.of({ type: DESTROY_PUBLIC_HOLIDAY_FAILURE, payload: response }))
    )
    .share()

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/effects/calendar.ts